import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-banner-simmer',
  templateUrl: './banner-simmer.component.html',
  styleUrls: ['./banner-simmer.component.css']
})
export class BannerSimmerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
